














import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

import Assets from '@/constants/assets';

export enum SpinnerSize {
    Auto = 'spinner--auto-size',
    Small = 'spinner--small-size',
}

export enum SpinnerEffect {
    Rotate = 'spinner--rotate',
}

@Component({
    components: {
    },
})
export default class InlineSpinner extends Vue {
    @Prop({ default: SpinnerSize.Auto }) private spinnerSize!: SpinnerSize;
    @Prop({ default: Assets.circleBlueGreen }) private spinnerAsset!: string;
    @Prop({ default: SpinnerEffect.Rotate }) private spinnerEffect!: SpinnerEffect;
    @Prop({ default: '' }) private spinnerText!: string;


    private assets = Assets;


    get hasText() {
        return this.spinnerText !== '';
    }
}
